export enum MatIconEnum {
  //Native Material UI Icons https://fonts.google.com/icons
  smartphone = 'smartphone',
  mail = 'mail_outline',
  //Custom OWL Icons
  owlSmartphone = 'owl-smartphone',
  owlMail = 'owl-mail'
}
